export const buttonTextSettingName = 'v3.configureShipmentWidget.actionButton';

// users sometimes have a bad value for their v3.configureShipmentWidget.actionButton
// we shouldn't crash the app if that's the case
const validButtonIds = ['createAndPrintLabel', 'createLabel'];

export const getValidButtonIdForGrid = (actionButtonId) => {
  if (!validButtonIds.includes(actionButtonId)) {
    return; // return undefined and let the CreateLabelButton handle switching to default via default props
  }
  return actionButtonId;
};
